import { render, staticRenderFns } from "./VentSettings.vue?vue&type=template&id=34ddd19c&scoped=true&"
import script from "./VentSettings.vue?vue&type=script&lang=ts&"
export * from "./VentSettings.vue?vue&type=script&lang=ts&"
import style0 from "./VentSettings.vue?vue&type=style&index=0&id=34ddd19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ddd19c",
  null
  
)

export default component.exports